import { BounceLoader } from "react-spinners";

const APILoading = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "300px",
      }}
    >
      <BounceLoader color="#22A699" loading={true} size={45} />
      <span
        style={{
          marginLeft: "8px",
          fontSize: "15px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        Please wait...
      </span>
    </div>
  );
};

export default APILoading;
